import { createAction } from "../../actions/actionUtils.js";
import { SYSTEM_NOTIFICATIONS } from "./notificationConstants.js";

const requestSystemNotifications = () => {
  return createAction(SYSTEM_NOTIFICATIONS.REQUEST);
};

const receiveSystemNotifications = payload => {
  return createAction(SYSTEM_NOTIFICATIONS.RECEIVE, payload);
};

const failureSystemNotifications = payload => {
  return createAction(SYSTEM_NOTIFICATIONS.FAILURE, payload);
};

// using the following export pattern so we can mock more easily using jest

const notificationActions = {
  requestSystemNotifications,
  receiveSystemNotifications,
  failureSystemNotifications
};

export default notificationActions;
